import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Caption3 from '../typography/captions/Caption3'
import Input from '../typography/Input'
import SortArrow from '../../static/images/icon_arrow_sort_ascending.svg'
import SortArrowHover from '../../static/images/icon_arrow_sort_ascending_hover.svg'
import DropdownTriangleIcon from '../../static/images/dropdown_triangle.svg'

const ComplexQuestsSortContainer = styled.div`
  display: inline-block;
  position: absolute;
  right: 0;
  top: 14px;

  * {
    transition: 0.3s all;
  }
`

const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const ActiveSortText = styled(Caption3)`
  text-transform: uppercase;
  cursor: pointer;
  display: flex;

  &:hover {
    cursor: pointer;
    color: black;
  }
`

const ActiveSortArrow = styled.div`
  background: url(${SortArrow}) no-repeat;
  height: 17px;
  width: 18px;
  transform: ${props =>
    props.activeDirection === 'desc' ? 'rotate(180deg)' : 'none'};

  &:hover {
    background: url(${SortArrowHover}) no-repeat;
    cursor: pointer;
  }
`

const SortOptionsContainer = styled.div`
  display: ${props => (props.visible ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: space-around;
  box-sizing: border-box;
  padding: 10px 19px;
  position: absolute;
  height: 77px;
  width: 153px;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  z-index: 21;
  top: 24px;
  left: -7px;
`

const SortOption = styled(Input)`
  cursor: ${props => (props.visible ? 'pointer' : 'default')};
  color: ${props => (props.active ? '#000000' : '#808080')};
`

const DropdownTriangle = styled.div`
  background: url(${DropdownTriangleIcon}) no-repeat;
  height: 5px;
  width: 9px;
  margin: 5px 24px 0 8px;
`

class ComplexQuestsSort extends React.Component {
  constructor() {
    super()
    this.state = {
      optionsVisible: false
    }

    this.optionsRef = React.createRef()
    this.onShowOptionsBound = this.onShowOptions.bind(this)
    this.onHideOptionsBound = this.onHideOptions.bind(this)
    this.onActiveSortTextClickBound = this.onActiveSortTextClick.bind(this)
    this.onSortTypeClickBound = this.onSortTypeClick.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  render() {
    return (
      <ComplexQuestsSortContainer>
        <InnerContainer>
          <ActiveSortText onClick={this.onActiveSortTextClickBound}>
            {this.getActivePropertyText()}
            <DropdownTriangle />
          </ActiveSortText>
          <SortOptionsContainer
            innerRef={this.optionsRef}
            visible={this.state.optionsVisible}
          >
            {this.props.options.map(o => (
              <SortOption
                visible={this.state.optionsVisible}
                key={o.value}
                active={this.props.activeProperty === o.value}
                onClick={this.onSortTypeClickBound}
                data-value={o.value}
              >
                {o.label}
              </SortOption>
            ))}
          </SortOptionsContainer>
          <ActiveSortArrow
            activeDirection={this.props.activeDirection}
            onClick={() => this.props.handleChangeSortDirectionClick()}
          />
        </InnerContainer>
      </ComplexQuestsSortContainer>
    )
  }

  onShowOptions() {
    this.setState(() => ({
      optionsVisible: true
    }))
  }

  onHideOptions() {
    this.setState(() => ({
      optionsVisible: false
    }))
  }

  getActivePropertyText() {
    return this.props.options.find(o => o.value === this.props.activeProperty)
      .label
  }

  onActiveSortTextClick() {
    this.setState(state => ({
      optionsVisible: !state.optionsVisible
    }))
  }

  async onSortTypeClick(event) {
    await this.props.handleChangeSortTypeClick(event.target.dataset.value)
    this.setState(() => ({
      optionsVisible: false
    }))
  }

  handleClickOutside(event) {
    if (
      this.state.optionsVisible &&
      this.optionsRef &&
      this.optionsRef.current &&
      !this.optionsRef.current.contains(event.target)
    ) {
      this.setState(() => ({
        optionsVisible: false
      }))
    }
  }
}

ComplexQuestsSort.propTypes = {
  activeProperty: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  activeDirection: PropTypes.string.isRequired,
  handleChangeSortDirectionClick: PropTypes.func.isRequired,
  handleChangeSortTypeClick: PropTypes.func.isRequired
}

export default ComplexQuestsSort



// WEBPACK FOOTER //
// ./src/components/mini/ComplexQuestsSort.js